import { useMutation } from '@tanstack/react-query';
import { showToast } from '../utils/toast';
import {
  authService,
  SocialLoginUrlResponse,
  SocialLoginParams,
  OAuthCallbackParams,
  OAuthCallbackResponse
} from '../services/auth';

// Hook for getting social login URL
export function useSocialLogin() {
  return useMutation({
    mutationFn: async (params: SocialLoginParams): Promise<SocialLoginUrlResponse> => {
      return authService.getSocialLoginUrl(params);
    },
    onSuccess: (data) => {
      // Redirect to OAuth provider
      window.location.href = data.loginUrl;
    },
    onError: (error) => {
      console.error('Failed to get social login URL:', error);
      showToast.error('Failed to initiate social login. Please try again.');
    },
  });
}

// Hook for handling OAuth callback
export function useOAuthCallback() {
  return useMutation({
    retry: false,
    mutationFn: async (params: OAuthCallbackParams): Promise<OAuthCallbackResponse> => {
      return authService.handleOAuthCallback(params);
    },
    // onSuccess: () => {
    //   showToast.success('Login successful!');
    // },
    onError: (error) => {
      console.error('OAuth callback failed:', error);
      showToast.error('Authentication failed. Please try again.');
    },
  });
}
